import { decodeURL } from './common';

export const convertVariableName = (name) => {
  return name.split('-').join('_');
};

export const parseURL = (url) => {
  const a = document.createElement('a');
  a.href = url;
  return {
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (() => {
      const ret = {};
      const seg = a.search.replace(/^\?/, '').split('&');
      let i = 0;
      let s;
      for (; i < seg.length; i++) {
        if (!seg[i]) {
          continue;
        }
        s = seg[i].split('=');
        ret[convertVariableName(s[0])] = decodeURL(s[1]);
      }
      return ret;
    })(),
    hash: a.hash.replace('#', ''),
  };
};
